import * as React from "react"
import * as ReactDOM from "react-dom"
import * as moment from 'moment';

import {omit} from 'lodash';

import { default as GlobalPeriodPicker } from '../utils/period_picker/GlobalPeriodPicker'
import { StartEnd, PrefixProps } from '../utils/period_picker/PeriodPicker'
import { FocusedInputShape } from 'react-dates';


declare var $: any;

declare var I18n : { locale: string, t: (_:string) => string }


type Props = StartEnd & PrefixProps & {
  startDateSelector: string
  endDateSelector: string
}

type State = StartEnd & {
  focusedInput: FocusedInputShape
}

export default class AdhocPeriodPicker extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
      startDate: this.props.startDate ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate: this.props.endDate ? moment(this.props.endDate, "DD-MM-YYYY") : null,
      focusedInput: null,
    }
  }

  onDatesChange(range: StartEnd) {
    this.setState({ ...range  }, () => {
      $(this.props.startDateSelector).val(range.startDate ? range.startDate.format("DD-MM-YYYY") : '')
      $(this.props.endDateSelector).val(range.endDate ? range.endDate.format("DD-MM-YYYY") : '')
    });
  }

  render() {
    return (
      <div>
        <div>
          <label className="select optional control-label">{I18n.t("rental_adverts.period_picker.from")}</label>
          <label className="select optional control-label">{I18n.t("rental_adverts.period_picker.to")}</label>
        </div>
        <GlobalPeriodPicker
          prefix={this.props.prefix}
          onDatesChange={(range: StartEnd) => this.onDatesChange(range)}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          disabled={false}
          onFocusChange={(fi) => this.setState({ focusedInput: fi })}
          focusedInput={this.state.focusedInput}
        />
      </div>
    )
  }
}
